import { Dropdown } from 'antd';
import { constant } from './constants';
import CustomMicrophoneIcon from './Utils/Icon';
import translation from '../../utils/translation';
import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import SpeechRecognition from 'react-speech-recognition';
import { RightOutlined, SelectOutlined } from '@ant-design/icons';
import { ChatButton, Form, StyledTextareaAutosize } from './CSS/styles';
import {
  clearChatForConversation,
  createConversation,
  enableDisableDebugMode
} from './Utils/ApICalls';

const ChatInput = (props) => {
  const { 
    chatId, 
    messages, 
    onNewUserMessage, 
    onNewChatCreated, 
    getConversationList 
  } = props;

  const translationCache = useSelector(state => state.TranslationReducer.translationCache);
  
  const [message, setMessage] = useState('');
  const [listening, setListening] = useState(false);

  useEffect(() => {
    SpeechRecognition.onresult = handleResult;
    return () => {
      SpeechRecognition.onresult = null;
    };
  }, []);

  const handleResult = (event) => {
    setMessage(event.results[0][0].transcript);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (message.trim() === '') return;

    if (chatId) {
      onNewUserMessage(chatId, message);
    } else {
      const saveResponse = await createConversation();
      if (saveResponse && saveResponse.Id) {
        onNewChatCreated(saveResponse.Id, message);
      }
    }
    setMessage('');
  };

  const setDebugMode = async (e, operation) => {
    e.preventDefault();
    const getLastRecord = messages && Array.isArray(messages) ? messages[messages.length - 1] : [];
    const setNextDebugValue = 
      getLastRecord?.DebugStatus === 'ENABLED' ? 'DISABLED' : 'ENABLED';

    let debugResponse = {};
    if (operation === 'DebugMode') {
      debugResponse = await enableDisableDebugMode(chatId, setNextDebugValue);
    } else if (operation === 'ClearMessages') {
      debugResponse = await clearChatForConversation(chatId);
    }

    if (debugResponse && debugResponse.message) {
      getConversationList(chatId);
    }
  };

  const onmic = (e) => {
    e.preventDefault();
    if (!listening) {
      SpeechRecognition.startListening();
      setListening(true);
    } else {
      SpeechRecognition.stopListening();
      setListening(false);
    }
  };

  const getLastRecord = messages && Array.isArray(messages) ? messages[messages.length - 1] : [];
  const setNextDebugValue = 
    getLastRecord?.DebugStatus === 'DISABLED' ? 'ENABLED' : 'DISABLED';

  const items = [
    {
      key: '1',
      label: (
        <div onClick={(e) => setDebugMode(e, 'DebugMode')}>
          {`${setNextDebugValue === translation(translationCache, constant.DISABLED)
            ? translation(translationCache, constant.Disable_Debug_Mode)
            : translation(translationCache, constant.Enable_Debug_Mode)}`}
        </div>
      )
    },
    {
      key: '2',
      label: (
        <div onClick={(e) => setDebugMode(e, 'ClearMessages')}>
          {translation(translationCache, constant.Clear_Messages)}
        </div>
      )
    }
  ];

  return (
    <Form onSubmit={handleSubmit}>
      <StyledTextareaAutosize
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={translation(translationCache, constant.Type_A_Message)}
        maxRows={10}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
          }
        }}
      />
      <ChatButton style={{ marginRight: '6px' }} onClick={onmic}>
        <CustomMicrophoneIcon />
      </ChatButton>
      <ChatButton style={{ marginRight: '6px' }}>
        <Dropdown menu={{ items }} placement="top" arrow>
          <SelectOutlined />
        </Dropdown>
      </ChatButton>
      <ChatButton type="submit">
        <RightOutlined />
      </ChatButton>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ChatInput);
